import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@common/directives/directives.module';
import { UIModule } from '@common/UI/UI.module';
import { CoreModule } from '@core/core.module';
import { NgxLoadingModule } from 'ngx-loading';
import { GeneralReportComponent } from './general-report/general-report.component';
import { InventoryReportByCustomersComponent } from './inventory-report-by-customers/inventory-report-by-customers.component';
import { InventoryReportByImportsComponent } from './inventory-report-by-imports/inventory-report-by-imports.component';
import { InventoryReportByProductsComponent } from './inventory-report-by-products/inventory-report-by-products.component';
import { PaymentReportComponent } from './payment-report/payment-report.component';
import { PriceReportByProductsComponent } from './price-report-by-products/price-report-by-products.component';
import { ReportsComponent } from './reports.component';
import { FormsModule } from '@angular/forms';
import { ImportsViewerComponent } from './inventory-report-by-products/imports-viewer/imports-viewer.component';
import { ExportsViewerComponent as ExportsViewerByProduct } from './inventory-report-by-products/exports-viewer/exports-viewer.component';
import { InitialViewerComponent } from './inventory-report-by-products/initial-viewer/initial-viewer.component';
import { RemainingViewerComponent } from './inventory-report-by-products/remaining-viewer/remaining-viewer.component';
import { ReturnsViewerComponent as ReturnsViewerByProduct } from './inventory-report-by-products/returns-viewer/returns-viewer.component';

import { ExportsViewerComponent as ExportsViewerByImport } from './inventory-report-by-imports/exports-viewer/exports-viewer.component';
import { ReturnsViewerComponent as ReturnsViewerByImport } from './inventory-report-by-imports/returns-viewer/returns-viewer.component';

import { ExportsViewerComponent as ExportsViewerByCustomer } from './inventory-report-by-customers/exports-viewer/exports-viewer.component';
import { ReturnsViewerComponent as ReturnsViewerByCustomer } from './inventory-report-by-customers/returns-viewer/returns-viewer.component';
import { PaymentReportsViewerComponent } from './payment-report/payment-reports-viewer/payment-reports-viewer.component';
import { InvoicesModule } from '@routes/invoices/invoices.module';



@NgModule({
  declarations: [
    ReportsComponent,
    InventoryReportByCustomersComponent,
    InventoryReportByProductsComponent,
    InventoryReportByImportsComponent,
    PaymentReportComponent,
    PriceReportByProductsComponent,
    GeneralReportComponent,
    ImportsViewerComponent,
    ExportsViewerByProduct,    
    InitialViewerComponent,
    RemainingViewerComponent,
    ReturnsViewerByProduct,

    ExportsViewerByImport,

    ExportsViewerByCustomer,
    ReturnsViewerByCustomer,
    ReturnsViewerByImport,
    PaymentReportsViewerComponent,
  ],
  imports: [
    CoreModule,
    UIModule,
    DirectivesModule,
    CommonModule,
    RouterModule,
    NgxLoadingModule,
    FormsModule,
    InvoicesModule,
  ]
})
export class ReportsModule { }
